var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no.2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jobcare---Tablet---1112-x-834-px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-3---Hazards-&-Controls_expanded",
    transform: "translate(-60.000000, -331.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-to-use-it/expanded",
    transform: "translate(40.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no.2",
    transform: "translate(20.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Droplets",
    fill: "#CFEDF1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9489882,0.271159322 C24.7573244,0.271159322 31.8981647,7.25773559 31.8981647,15.8763119 C31.8981647,24.4948881 24.7573244,31.4814644 15.9489882,31.4814644 C7.1406521,31.4814644 8.06722689e-05,24.4948881 8.06722689e-05,15.8763119 L8.06722689e-05,0.271159322 L15.9489882,0.271159322 Z M16.128242,3.40794576 C9.27056134,3.40794576 3.71116639,9.01445424 3.71116639,15.9302508 C3.71116639,22.8460475 9.27056134,28.4525559 16.128242,28.4525559 C22.9859227,28.4525559 28.5453176,22.8460475 28.5453176,15.9302508 C28.5453176,9.01445424 22.9859227,3.40794576 16.128242,3.40794576 Z"
  })), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fontFamily: "NunitoSans-Bold, Nunito Sans",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#213D58"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 21
  }, "2"))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo2);
export default __webpack_public_path__ + "static/media/no.2.55948b72.svg";
export { ForwardRef as ReactComponent };